import { StorageService } from './StorageService';

export class User {
  name: string = 'Player';
  lives: number = 3;
  continues: number = 2;
  coins: number = 0;
  intro: boolean = false;
  levelStats: LevelStat[] = [];
  settings: UserSettings = {
    enableMusic: false,
    enableSound: true,
    enableSpeech: true,
    volumeMusic: 0.25,
    volumeSound: 0.75,
    volumeSpeech: 0.75,
  };

  static async load(): Promise<User> {
    const data = await StorageService.readObject<User>('platformia3d_user');
    if (!data) {
      const user = new User();
      user.save();
      return user;
    }
    return new User(data);
  }

  constructor(data?: any) {
    if (data) {
      for (const p in data) {
        this[p] = data[p];
      }
    }
  }

  async save(): Promise<void> {
    return StorageService.saveObject('platformia3d_user', this);
  }

  hasContinues(): boolean {
    if (this.continues < 1) {
      return false;
    }
    return true;
  }

  reset() {
    this.lives = 3;
    this.continues = 2;
    this.coins = 0;
    this.levelStats = [];
  }

  useContinue() {
    if (!this.hasContinues()) {
      return;
    }
    this.continues--;
    this.lives = 3;
    this.coins = 0;
  }

  isUnLocked(level: number) {
    if (level == 1) {
      return true;
    }
    return level <= this.getMaxLevel() + 1;
  }

  getMaxLevel() {
    let maxlevel = 0;
    for (let i = 0; i < this.levelStats.length; i++) {
      if (this.levelStats[i].level > maxlevel) {
        maxlevel = this.levelStats[i].level;
      }
    }
    return maxlevel;
  }

  getTotalScore() {
    let score = 0;
    for (let i = 0; i < this.levelStats.length; i++) {
      score += this.levelStats[i].score;
    }
    return score;
  }

  getLevelStat(level: number): LevelStat {
    for (let i = 0; i < this.levelStats.length; i++) {
      if (this.levelStats[i].level == level) {
        return this.levelStats[i];
      }
    }
    return null;
  }

  setLevelStat(level: number, score: number): boolean {
    let create: boolean = true;
    for (let i = 0; i < this.levelStats.length; i++) {
      if (this.levelStats[i].level == level) {
        if (this.levelStats[i].score < score) {
          this.levelStats[i].score = score;
        }
        create = false;
      }
    }
    if (create) {
      this.levelStats.push({ level, score });
    }
    return create;
  }
}

export interface LevelStat {
  score: number;
  level: number;
}

export interface UserSettings {
  enableMusic: boolean;
  enableSound: boolean;
  enableSpeech: boolean;

  volumeMusic: number;
  volumeSound: number;
  volumeSpeech: number;
}
